import {Component, Input, OnChanges} from '@angular/core';
import {NgIf} from "@angular/common";
import {HighchartsChartModule} from 'highcharts-angular';
import Highcharts from 'highcharts';
import {WIDGET_COLOR_SCALE} from '../../../../../shared/types/common';
import {graphSpec} from '../../../types';
const greyColor = '#4E5258';
const fontFamily = 'Poppins, sans-serif';

@Component({
  selector: 'app-copilot-graphs-message',
  imports: [
    HighchartsChartModule,
    NgIf,
  ],
  templateUrl: './copilot-graphs-message.component.html',
  styleUrl: './copilot-graphs-message.component.scss'
})
export class CopilotGraphsMessageComponent implements OnChanges{
  @Input() data!: graphSpec | undefined;
  protected readonly Highcharts = Highcharts;

  colors = WIDGET_COLOR_SCALE;
  chartOptions!: Highcharts.Options;

  ngOnChanges(): void {
    if (this.data)
      this.chartOptions=this.createHighchartsOptions(this.data);
  }
  private createHighchartsOptions(data: any): Highcharts.Options {
    if (data.type === 'doughnut') {
      return {
        chart: {
          type: 'pie',
          style: {
            fontFamily: fontFamily
          }
        },
        title: {
          text: data.title || '',
          style: {
            fontFamily: fontFamily,
            color: greyColor,
            fontWeight: '600'
          },
        },
        tooltip: {
          useHTML: true,
          backgroundColor: 'rgba(255,255,255,0)',
          borderWidth: 0,
          shadow: false,
          formatter:function () {
              return `<div style="text-align: center;border-radius:4px;box-shadow:0px 0px 6px 0px rgba(0, 0, 0, 0.10);min-width:80px;padding: 4px 8px; margin: 3px; backgroundColor: white">
                        <div style="font-weight:400;font-size:12px;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background-color:${this.color};margin-right:6px;"></span>${this.key}</div>
                        <div style="font-weight:600;font-size:14px;">${this.y}</div>
                      </div>`;
            },
          style: {
            fontFamily: fontFamily,
            color: greyColor
          },
        },
        plotOptions: {
          pie: {
            innerSize: '60%',
            borderWidth: 0,
            borderRadius: 0,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.name}: <span style="font-weight: 600">{point.y}{series.userOptions.unit}</span>',
              style: {
                fontFamily: fontFamily,
                color: greyColor,
                fontWeight: 'normal',
                fontSize: '12.8px',
              },
            }
          }
        },
        credits: {
          enabled: false,
        },
        colors: this.colors,
        series: (data.series || []).map((s: any) => ({
          name: s.name,
          colorByPoint: true,
          data: (data.x || []).map((xVal: any, i: any) => ({
            name: xVal,
            y: s.y[i],
            unit: s.unit || ''
          })),
          style: {
            fontFamily: fontFamily,
            color: greyColor
          },
        }))
      };
    }
    return {
      chart: {
        type: data.type || 'bar',
        style: {
          fontFamily: fontFamily
        }
      },
      title: {
        text: data.title || '',
        style: {
          fontFamily: fontFamily,
          color: greyColor,
          fontWeight: '600'
        },
      },
      xAxis: {
        categories: data.x || [],
        title: {
          text: data.x_axis || null,
          style: {
            fontFamily: fontFamily,
            color: greyColor
          },
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: data.y_axis || null,
          align: 'high',
          style: {
            fontFamily: fontFamily,
            color: greyColor
          },
        },
        labels: {
          format: data.y_is_percentage ? '{value}%' : '{value}',
          style: {
            fontFamily: fontFamily,
            color: greyColor
          },
        }
      },
      tooltip: {
        shared: true,
        useHTML: true,
        headerFormat: '<div style="font-size:12.8px;font-weight:600;margin-bottom:6px;">{point.key}</div>',
        pointFormat: '<div style="padding:3px 0; font-size: 12.8px;"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background-color:{series.color};margin-right:6px;"></span><span style="color:#4E5258">{series.name}</span>: <span style="font-weight: 600">{point.y} {series.userOptions.unit}</span></div>',
        style: {
          fontFamily: fontFamily,
          minWidth: '120px',
        },
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: data.y_is_percentage ? '{y}%' : '{y}',
            style: {
               fontFamily: fontFamily,
              color: greyColor,
              fontWeight: '600'
              },
          }
        }
      },
      credits: {
        enabled: false,
      },
      colors: this.colors,
      series: (data.series || []).map((s: any) => ({
        name: s.name,
        data: s.y,
        unit: s.unit || '',
        marker: {enabled: false, symbol: 'circle', radius: 5, states: {hover: {enabled: true}}},
        style: {
          fontFamily: fontFamily,
          color: greyColor
        },
      }))
    };
  }
}
